import React, { useCallback, useContext, useMemo, useState } from "react";
import { verifyOTPAndFetchUserInfo } from "../services/LoginServices";
import { decryptData, encryptData } from "../utility/encryptionUtility";

const AuthContext = React.createContext({
  isLoggedIn: false,
  onLogout: () => {},
  onLogin: () => {},
});

const AuthContextProvider = (props) => {
  let loginStatusFromSession = sessionStorage.getItem("isLoggedIn");
  if (loginStatusFromSession)
    loginStatusFromSession = decryptData(loginStatusFromSession);

  const [isLoggedIn, setIsLoggedIn] = useState(loginStatusFromSession ?? false);
  const [autheticatedByServer, setAutheticatedByServer] = useState(false);

  const onLogout = useCallback(() => {
    setIsLoggedIn(false);
    setAutheticatedByServer(false);
    sessionStorage.clear();
  }, []);

  const onLogin = useCallback(async (email, passCode, reCaptchaToken) => {
    const response = await verifyOTPAndFetchUserInfo(
      passCode,
      email,
      reCaptchaToken
    );
    if (response.status === 0) {
      setIsLoggedIn(true);
      sessionStorage.setItem("isLoggedIn", encryptData(true));

      const userInfo = response.data.userInfo;
      userInfo.group = response.data.group;
      return { isError: false, userInfo };
    } else {
      return {
        isError: true,
        title: response.title,
        message: response.message,
      };
    }
  }, []);

  const markUserAsLoggedIn = useCallback(() => {
    sessionStorage.setItem("isLoggedIn", encryptData(true));
    setIsLoggedIn(true);
  }, []);

  const markUserAsAutheticatedByServer = useCallback(() => {
    setAutheticatedByServer(true);
  }, []);

  const contextValue = useMemo(
    () => ({
      isLoggedIn,
      isAutheticatedByServer: autheticatedByServer,
      onLogout,
      onLogin,
      markUserAsLoggedIn,
      markUserAsAutheticatedByServer,
    }),
    [
      isLoggedIn, 
      autheticatedByServer, 
      onLogout, 
      onLogin, 
      markUserAsLoggedIn, 
      markUserAsAutheticatedByServer
    ]
  );
  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

export { AuthContextProvider, useAuth };
